export const RoutePostReportPowerBIWorkspace = "/report/powerbi/workspace";

export interface ResponsePostReportPowerBIWorkspace {
  workspaceId: string;
  workspaceName: string;
  created: boolean;
}
